import React from 'react';
import { Table } from 'react-bootstrap';
import THead from "./components/THead";
import Row from "./components/Row";
import { sortArray } from "../../../../Utils";

const DaysCountryTable = ({ reportObj, device, countries, sortParam, sortOrder, onSortChange }) => {
    const { report, days } = reportObj;
    const rowsData = getRowsData(report, days, device, countries);

    if(sortParam) sortArray(rowsData, sortParam, sortOrder);

    const rows = rowsData.map(row => <Row {...row} days={days} key={`${row.affid}:${row.country}:${row.device}`}/>);

    return (
        <Table bordered responsive>
            <THead days={days} onSortChange={onSortChange}/>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

function getRowsData(report, days, selectedDevice, countries) {
    return report.reduce((arr, row) => {
        let isMatchFilters = true;

        if(countries.length && countries.indexOf(row.country) === -1) isMatchFilters = false;
        else if(selectedDevice && selectedDevice !== row.device ) isMatchFilters = false;

        if(isMatchFilters) arr.push(row);

        return arr;
    }, []);
}

export default DaysCountryTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderECost/components/DaysCountryTable/index.js